import {
  chakra,
  ComponentWithAs,
  IconProps,
  Text,
  TextProps,
} from '@chakra-ui/react'
import React from 'react'

import {
  Tooltip,
  TooltipProps,
} from '~shared-components/components/Tooltip/Tooltip'
import { IconCircleInfoFilled } from '~shared-components/icons/brand/IconCircleInfoFilled'
export interface InputLabelProps extends TextProps {
  required?: boolean
}

export const InputLabel: React.FC<InputLabelProps> = ({
  children,
  color = 'neutral.50',
  required,
  ...restProps
}) => (
  <Text
    _after={
      required
        ? {
            color: 'red.70',
            content: '"*"',
            display: 'inline-block',
          }
        : undefined
    }
    as="label"
    color={color}
    fontSize="md"
    mb={1}
    {...restProps}
  >
    {children}
  </Text>
)

export interface InputLabelWithTooltipProps extends InputLabelProps {
  icon?: ComponentWithAs<'svg', IconProps>
  tooltip: TooltipProps['label']
}
export const InputLabelWithTooltip: React.FC<InputLabelWithTooltipProps> = ({
  children,
  tooltip,
  icon: Icon = IconCircleInfoFilled,
  required,
}) => (
  <chakra.span>
    <InputLabel required={required}>{children} </InputLabel>
    <Tooltip hasArrow label={tooltip}>
      <Icon boxSize="20px" color="neutral.70" ml={1} />
    </Tooltip>
  </chakra.span>
)
